/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ProfileNoteAuthorResponse {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  avatar_url?: string | null;
}
